import { logD } from "@blacknut/logging/dist";
import { Game } from "../../model";
import { apiService, TAG } from "../ApiService";

export declare type RecentlyPlayedListSortMethod = "name" | "createdat" | "genre";

export interface GetRecentlyPlayedGamesResponse {
  games: Game[];
  meta: {
    total: number;
    offset: number;
    limit: number;
    sort: RecentlyPlayedListSortMethod;
    page: number;
    next: number;
    totalPages: number;
  };
}
export const getRecentlyPlayedGames = (
  sortBy: RecentlyPlayedListSortMethod,
  page = 1,
  limit?: number,
) => {
  logD(TAG, `Getting last played`);
  return apiService.get<GetRecentlyPlayedGamesResponse>({
    path: `v1/me/last_played`,
    params: {
      page: `${page}`,
      limit: `${limit || 10}`,
      sort: sortBy,
    },
    requiresAuthPolicy: "user",
  });
};
